/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { Link, withRouter } from 'react-router-dom';
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap';
import getAddressByCep from '../../../../app/services/viaCep';
import { createBranch, getBranch, updateBranch } from '../../../../app/store/actions/branches';
import { getCompaniesOptions } from '../../../../app/store/actions/companies';
import { getDepositsOptions } from '../../../../app/store/actions/deposits';
import { getPackagesList } from '../../../../app/store/actions/packages';
import { getUsersOptions } from '../../../../app/store/actions/users';
import OneClickButton from '../../../../components/form/button';
import Select from '../../../../components/form/select';
import addNotification from '../../../../components/notification';
import {
  Panel, PanelBody, PanelFooter, PanelHeader,
} from '../../../../components/panel/panel';
import ROUTES from '../../../../config/routes';
import BranchHelpers from '../../../../helpers/branches';
import Form from '../../../../components/form/form';
import FormatHelpers from '../../../../helpers/format';

import { getOrdersTypeOptions } from '../../../../app/store/actions/typeOrder';
import { getAllQRCodes } from '../../../../app/store/actions/QRCodeConfig';

const colourStyles = {
  control: (styles) => ({ ...styles, backgroundColor: 'white' }),
  option: (styles, { isDisabled, isSelected }) => ({
    ...styles,
    backgroundColor: isDisabled ? 'grey' : 'white',
    color: isDisabled ? 'grey' : 'black',
    cursor: isDisabled ? 'not-allowed' : 'default',
    textAlign: 'left',

    ':hover': {
      ...styles[':hover'],
      backgroundColor: isSelected ? 'grey' : '#eb900a',
      color: 'white',
    },
  }),
};

const getSoundAlertStatusesFromBranch = (branchSelected, listSoundAlertStatuses) => {
  if (branchSelected.trackingDashboardSoundStatuses) {
    const statuses = branchSelected.trackingDashboardSoundStatuses
      .split('|')
      .map(Number);

    return listSoundAlertStatuses.filter((status) => statuses.includes(status.value));
  }

  const selectedStatuses = [];

  if (branchSelected.trackingDashboardSoundOnBilling) {
    selectedStatuses.push(
      ...listSoundAlertStatuses.filter((status) => status.value === 9),
    );
  }

  if (branchSelected.trackingDashboardActivateSound) {
    selectedStatuses.push(
      ...listSoundAlertStatuses.filter((status) => status.value === 14),
    );
  }

  return selectedStatuses;
};

const getTrackingDashboardSoundPayload = (trackingDashboardSoundStatuses) => {
  const selectedValues = (trackingDashboardSoundStatuses || [])
    .map((item) => Number(item.value));

  return {
    trackingDashboardSoundOnBilling: selectedValues.includes(9),
    trackingDashboardActivateSound: selectedValues.includes(14),
    trackingDashboardSoundStatuses: selectedValues
      .sort((a, b) => a - b)
      .join('|'),
  };
};

class BranchForm extends React.Component {
  constructor(props) {
    super(props);

    this.handleInputChange = this.handleInputChange.bind(this);

    const listOutboundOrderStatus = [
      {
        value: 1,
        label: I18n.t('BEE1946' /* Pendente Alocação */),
      },
      {
        value: 2,
        label: I18n.t('BEE1947' /* Pendente Corte de Cabos */),
      },
      {
        value: 3,
        label: I18n.t('BEE1365' /* Pendente Separação */),
      },
      {
        value: 4,
        label: I18n.t('BEE1367' /* Em Separação */),
      },
      {
        value: 5,
        label: I18n.t('BEE1948' /* Pendente Conferência */),
      },
      {
        value: 6,
        label: I18n.t('BEE1949' /* Pendente Docas */),
      },
      {
        value: 7,
        label: I18n.t('BEE1773' /* Pendente Romaneio */),
      },
      {
        value: 8,
        label: I18n.t('BEE1769' /* Pendente Consolidação */),
      },
      {
        value: 9,
        label: I18n.t('BEE2963' /* Pendente de Faturamento */),
      },
      {
        value: 14,
        label: I18n.t('BEE3687' /* Pendente Retirada */),
      },
    ];

    const listSoundAlertStatuses = listOutboundOrderStatus.filter(
      (status) => [9, 14].includes(status.value),
    );

    this.state = {
      listOutboundOrderStatus,
      listSoundAlertStatuses,
      activeTab: '1',
      mode: 'detail',
      disableCode: true,
      disableName: true,
      disableCompany: true,
      disableEmail: true,
      disablePhone: true,
      disableCNPJ: true,
      disableNote: true,
      disableStateRegistration: true,
      disablePostalCode: true,
      disableComplement: true,
      disableStreet: true,
      disableNumber: true,
      disableDistrict: true,
      disableCity: true,
      disableState: true,
      disableCountry: true,
      disableLimitProductsWave: true,
      disablePrefix: true,
      disableYellowLightValue: true,
      disableGreenLightValue: true,
      yellowLightValue: 0,
      greenLightValue: 0,
      showCreate: false,
      showUpdate: false,
      showCancel: false,
      disableMandatoryComplementAddress: true,
      restrictSearchSepDoc: false,
      disableRestrictSearchSepDoc: true,
      code: '',
      name: '',
      company: '',
      companyName: '',
      email: '',
      phone: '',
      cnpj: '',
      stateRegistration: '',
      postalCode: '',
      street: '',
      number: '',
      complement: '',
      city: '',
      district: '',
      state: '',
      note: '',
      listCompany: '',
      limitProductsWave: 0,
      prefix: '',
      notConfirmProductWaveTransfer: false,
      dockPrintConsolidation: false,
      ruleSelect: [],
      rulesPriority: [],
      prioritySuggest: [],
      requestWeightDimensions: false,
      mandatoryWeightDimensions: false,
      preConference: false,
      receiveLeftover: false,
      partialInboundCheck: false,
      productAddressBranchCapacity: false,
      disableProductAddressBranchCapacity: true,
      inboundCheckPlate: false,
      separationMode: 1,
      disableMandatoryProduct: true,
      disableRule: true,
      packageCode: null,
      packageName: '',
      preReceiptDeposit: null,
      preReceiptName: '',
      inboundDeposit: null,
      inboundName: '',
      resaleDeposit: null,
      resaleName: '',
      inventoryDeposit: null,
      inventoryName: '',
      divergenceDeposit: null,
      divergenceName: '',
      separationDivergenceDeposit: null,
      separationDivergenceName: '',
      damageDeposit: null,
      damageName: '',
      rejectedDeposit: null,
      rejectedName: '',
      qualityDeposit: '',
      qualityName: '',
      spareDeposit: null,
      spareName: '',
      intermediaryDeposit: null,
      intermediaryName: '',
      factoryDeposit: null,
      factoryName: '',
      crossdockingDeposit: null,
      crossdockingName: '',
      disableDeposits: true,
      disablePackage: true,
      listDeposit: [],
      listPackages: [],
      withdrawUser: null,
      branchInInventory: false,
      serialControlDeposit: false,
      pickingByLoad: false,
      usesCableCuttingPlan: false,
      usesCarrierSchedule: false,
      dispatch: false,
      consolidation: false,
      dockControl: false,
      blindConference: false,
      automaticSeparationAfterCuttingCables: false,
      automaticCheckAfterPicking: false,
      disablePickingByLoad: true,
      disableUsesCableCuttingPlan: true,
      disableBranchInInventory: true,
      disableSerialControlDeposit: true,
      mandatoryComplementAddress: true,
      requestResupplyQuantity: false,
      disableRequestResupplyQuantity: true,
      rulesPriorityResupply: [],
      prioritySuggestResupply: [],
      rulesResupply: [],
      restrictionPicking: false,
      limitResupplyUser: 0,
      disableLimitResupplyUser: true,
      disableNotConfirmProductWaveTransfer: true,
      automaticReallocation: false,
      disableAutomaticReallocation: true,
      conferenceWithDivergence: false,
      disableConferenceWithDivergence: true,
      disabledDockPrintConsolidation: true,
      disableGenerateInventoryForSeparationDiscrepancy: true,
      generateInventoryForSeparationDiscrepancy: true,
      autoFinalizeNoDivergence: false,
      disableAutoFinalizeNoDivergence: true,
      enableStockMirror: false,
      disableEnableStockMirror: true,
      trackingDashboardSpeakOrderNumber: false,
      trackingDashboardSpeakCustomerName: false,
      trackingDashboardSoundStatuses: [],
      disabletrackingDashboardSpeakOrderNumber: true,
      disabletrackingDashboardSpeakCustomerName: true,
      disableTrackingDashboardColumnSequence: true,
      disableTrackingDashboardOrderTypes: true,
      disableTrackingDashboardSoundStatuses: true,
      trackingDashboardColumnSequence: '',
      trackingDashboardOrderTypes: [],
      assignPickingWave: true,
      assignPickingDocument: true,
      assignPickingLoad: true,
      disableAssignPickingWave: true,
      disableAssignPickingDocument: true,
      disableAssignPickingLoad: true,
      listOrderTypes: [],
      usesQrCode: false,
      disableUsesQrCode: true,
      qrCodeModelCode: null,
      qrCodeModelName: '',
      allocateBalanceAfterResupply: true,
      disableAllocateBalanceAfterResupply: true,
    };
  }

  async componentDidMount() {
    await this.setMode();

    const listDeposit = await this.props.getDepositsOptions();
    this.setState({
      listDeposit,
    });

    const listQRCodes = await this.props.getAllQRCodes();
    this.setState({
      listQRCodes: listQRCodes.map((item) => ({ value: item.code, label: `${item.code} - ${item.description}` })),
    });

    if (this.state.mode !== 'create') {
      await this.getBranchSelected();
    }

    const rulesPriorityResupply = await this.rulesPriorityResupply();

    const rulesPriority = await this.rulePriority();

    if (rulesPriority) {
      this.setState({
        rulesPriority,
      });
    }

    if (rulesPriorityResupply) {
      this.setState({
        rulesPriorityResupply,
      });
    }

    const listCompany = await this.props.getCompaniesOptions();

    await this.props.getPackagesList();
    const listPackages = this.props.packagesList.map((element) => ({
      value: element.code,
      label: `${element.code} - ${element.name}`,
    }));

    this.setState({
      listCompany,
      listPackages,
    });
  }

  handleInputChange(event) {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;

    if (name === 'serialControlDeposit') {
      this.setState({
        disableAutomaticReallocation: true,
        automaticReallocation: false,
      });
    } else if (name === 'automaticCheckAfterPicking') {
      if (value) {
        this.setState({
          disableConferenceWithDivergence: true,
          conferenceWithDivergence: false,
        });
      } else {
        this.setState({
          disableConferenceWithDivergence: false,
        });
      }
    } else if (name === 'usesQrCode' && !value) {
      this.setState({
        qrCodeModelCode: null,
        qrCodeModelName: '',
      });
    }

    this.setState({
      [name]: value,
    });
  }

  getBranchSelected = async () => {
    if (this.props.location.state.branch) {
      const { branch } = this.props.location.state;

      const branchSelected = await this.props.getBranch(branch.id);

      if (branchSelected) {
        let filteredStatus = '';
        let selectedOrderTypes = '';

        const listOrderTypes = await this.props.getOrdersTypeOptions();

        const filteredOrderTypes = listOrderTypes
          .filter((item) => item.branch === branchSelected.code)
          .map(({ value, label }) => ({ value, label }));

        if (branchSelected.trackingDashboardOrderTypes) {
          const trackingDashboardOrderTypes = branchSelected.trackingDashboardOrderTypes
            .split('|');

          selectedOrderTypes = filteredOrderTypes.filter((status) => trackingDashboardOrderTypes.includes(status.value));
        }

        if (branchSelected.trackingDashboardColumnSequence) {
          const trackingDashboardColumnSequence = branchSelected.trackingDashboardColumnSequence
            .split('|')
            .map(Number);

          filteredStatus = this.state.listOutboundOrderStatus.filter((status) => trackingDashboardColumnSequence.includes(status.value));
        }

        let qrName = '';
        if (branchSelected.usesQrCode) {
          qrName = this.state.listQRCodes.find(
            (item) => item.value === branchSelected.qrCodeModelCode,
          );
        }

        const { listSoundAlertStatuses } = this.state;
        const trackingDashboardSoundStatuses = getSoundAlertStatusesFromBranch(
          branchSelected,
          listSoundAlertStatuses,
        );

        this.setState({
          branchId: branchSelected.id,
          restrictSearchSepDoc: branchSelected.restrictSearchSepDoc,
          code: branchSelected.code,
          name: branchSelected.name,
          company: branchSelected.companyCode,
          companyName: branchSelected.companyName,
          email: branchSelected.email,
          phone: branchSelected.phone,
          cnpj: branchSelected.cnpj,
          stateRegistration: branchSelected.stateRegistration,
          note: branchSelected.note,
          postalCode: branchSelected.postalCode,
          ibge: branchSelected.ibge,
          street: branchSelected.street,
          city: branchSelected.city,
          number: branchSelected.number,
          complement: branchSelected.complement,
          district: branchSelected.district,
          state: branchSelected.state,
          country: branchSelected.country,
          limitProductsWave: branchSelected.limitProductsWave,
          requestWeightDimensions: branchSelected.requestWeightDimensions,
          mandatoryWeightDimensions: branchSelected.mandatoryWeightDimensions,
          preConference: branchSelected.preConference,
          receiveLeftover: branchSelected.receiveLeftover,
          productAddressBranchCapacity: branchSelected.productAddressBranchCapacity,
          partialInboundCheck: branchSelected.partialInboundCheck,
          inboundCheckPlate: branchSelected.inboundCheckPlate,
          separationMode: branchSelected.separationMode,
          prioritySuggest: branchSelected.prioritySuggest,
          preReceiptDeposit: branchSelected.preReceiptDeposit,
          inboundDeposit: branchSelected.inboundDeposit,
          resaleDeposit: branchSelected.resaleDeposit,
          inventoryDeposit: branchSelected.inventoryDeposit,
          divergenceDeposit: branchSelected.divergenceDeposit,
          separationDivergenceDeposit: branchSelected.separationDivergenceDeposit,
          damageDeposit: branchSelected.damageDeposit,
          rejectedDeposit: branchSelected.rejectedDeposit,
          qualityDeposit: branchSelected.qualityDeposit,
          spareDeposit: branchSelected.spareDeposit,
          intermediaryDeposit: branchSelected.intermediaryDeposit,
          factoryDeposit: branchSelected.factoryDeposit,
          crossdockingDeposit: branchSelected.crossdockingDeposit,
          preReceiptName: branchSelected.preReceiptName,
          inboundName: branchSelected.inboundName,
          resaleName: branchSelected.resaleName,
          inventoryName: branchSelected.inventoryName,
          divergenceName: branchSelected.divergenceName,
          separationDivergenceName: branchSelected.separationDivergenceName,
          damageName: branchSelected.damageName,
          rejectedName: branchSelected.rejectedName,
          qualityName: branchSelected.qualityName,
          spareName: branchSelected.spareName,
          intermediaryName: branchSelected.intermediaryName,
          factoryName: branchSelected.factoryName,
          crossdockingName: branchSelected.crossdockingName,
          withdrawUser: branchSelected.withdrawUser,
          branchInInventory: branchSelected.branchInInventory,
          serialControlDeposit: branchSelected.serialControlDeposit,
          pickingByLoad: branchSelected.pickingByLoad,
          usesCableCuttingPlan: branchSelected.usesCableCuttingPlan,
          usesCarrierSchedule: branchSelected.usesCarrierSchedule,
          dispatch: branchSelected.dispatch,
          consolidation: branchSelected.consolidation,
          dockControl: branchSelected.dockControl,
          blindConference: branchSelected.blindConference,
          automaticSeparationAfterCuttingCables:
            branchSelected.automaticSeparationAfterCuttingCables,
          automaticCheckAfterPicking: branchSelected.automaticCheckAfterPicking,
          packageCode: branchSelected.package,
          packageName: branchSelected.packageName,
          mandatoryComplementAddress: branchSelected.mandatoryComplementAddress,
          requestResupplyQuantity: branchSelected.requestResupplyQuantity,
          prioritySuggestResupply: branchSelected.prioritySuggestResupply,
          restrictionPicking: branchSelected.restrictionPicking,
          limitResupplyUser: branchSelected.limitResupplyUser,
          prefix: branchSelected.prefix,
          notConfirmProductWaveTransfer: branchSelected.notConfirmProductWaveTransfer,
          automaticReallocation: branchSelected.automaticReallocation,
          conferenceWithDivergence: branchSelected.conferenceWithDivergence,
          dockPrintConsolidation: branchSelected.dockPrintConsolidation,
          generateInventoryForSeparationDiscrepancy:
            branchSelected.generateInventoryForSeparationDiscrepancy,
          autoFinalizeNoDivergence: branchSelected.autoFinalizeNoDivergence,
          yellowLightValue: branchSelected.yellowLightValue,
          greenLightValue: branchSelected.greenLightValue,
          enableStockMirror: branchSelected.enableStockMirror,
          trackingDashboardSpeakOrderNumber: branchSelected.trackingDashboardSpeakOrderNumber,
          trackingDashboardSpeakCustomerName: branchSelected.trackingDashboardSpeakCustomerName,
          trackingDashboardColumnSequence: filteredStatus,
          trackingDashboardOrderTypes: selectedOrderTypes,
          trackingDashboardSoundStatuses,
          assignPickingWave: branchSelected.assignPickingWave,
          assignPickingDocument: branchSelected.assignPickingDocument,
          assignPickingLoad: branchSelected.assignPickingLoad,
          listOrderTypes: filteredOrderTypes,
          usesQrCode: branchSelected.usesQrCode,
          qrCodeModelCode: branchSelected.qrCodeModelCode,
          qrCodeModelName: qrName ? qrName.label : '',
          allocateBalanceAfterResupply: branchSelected.allocateBalanceAfterResupply,
        });
      }

      const rulesPriorityResupply = await this.rulesPriorityResupply();
      const rulesPriority = await this.rulePriority();

      if (rulesPriority) {
        this.setState({
          rulesPriority,
        });
      }

      if (rulesPriorityResupply) {
        this.setState({
          rulesPriorityResupply,
        });
      }
    }
  };

  setMode = () => {
    let mode;
    if (this.props.isCreate) mode = 'create';
    else if (this.props.isCopy) mode = 'copy';
    else if (this.props.isEdit) mode = 'edit';
    else if (this.props.isDetail) mode = 'detail';
    else mode = '';

    if (mode === 'create' || mode === 'copy') {
      this.setState({
        mode,
        disableMandatoryComplementAddress: false,
        disableRestrictSearchSepDoc: false,
        disableCode: false,
        disableName: false,
        disableCompany: false,
        disableEmail: false,
        disablePhone: false,
        disableCNPJ: false,
        disableNote: false,
        disableStateRegistration: false,
        disablePostalCode: false,
        disableComplement: false,
        disableStreet: false,
        disableNumber: false,
        disableLimitProductsWave: false,
        disableDistrict: false,
        disableCity: false,
        disableState: false,
        disableCountry: false,
        disableMandatoryProduct: false,
        disableProductAddressBranchCapacity: false,
        disableRule: false,
        disableDeposits: false,
        disablePackage: false,
        disablePickingByLoad: false,
        disableUsesCableCuttingPlan: false,
        disableBranchInInventory: false,
        disableSerialControlDeposit: false,
        disablePrefix: false,
        showCreate: true,
        showUpdate: false,
        showCancel: true,
        disableRequestResupplyQuantity: false,
        disableLimitResupplyUser: false,
        disableNotConfirmProductWaveTransfer: false,
        disableAutomaticReallocation: false,
        disableConferenceWithDivergence: false,
        disabledDockPrintConsolidation: false,
        disableGenerateInventoryForSeparationDiscrepancy: false,
        disableAutoFinalizeNoDivergence: false,
        disableYellowLightValue: false,
        disableGreenLightValue: false,
        disableEnableStockMirror: false,
        disabletrackingDashboardSpeakOrderNumber: false,
        disabletrackingDashboardSpeakCustomerName: false,
        disableTrackingDashboardColumnSequence: false,
        disableTrackingDashboardOrderTypes: false,
        disableTrackingDashboardSoundStatuses: false,
        disableAssignPickingWave: false,
        disableAssignPickingDocument: false,
        disableAssignPickingLoad: false,
        disableUsesQrCode: false,
        disableAllocateBalanceAfterResupply: false,
      });
    } else if (mode === 'edit') {
      this.setState({
        mode,
        disableMandatoryComplementAddress: false,
        disableCode: true,
        disableRestrictSearchSepDoc: false,
        disableName: false,
        disableCompany: false,
        disableEmail: false,
        disablePhone: false,
        disableCNPJ: false,
        disableNote: false,
        disableStateRegistration: false,
        disablePostalCode: false,
        disableComplement: false,
        disableStreet: false,
        disableNumber: false,
        disableLimitProductsWave: false,
        disableDistrict: false,
        disableCity: false,
        disableState: false,
        disableCountry: false,
        disableMandatoryProduct: false,
        disableProductAddressBranchCapacity: false,
        disableRule: false,
        disableDeposits: false,
        disablePackage: false,
        disablePickingByLoad: false,
        disableUsesCableCuttingPlan: false,
        disableBranchInInventory: false,
        disableSerialControlDeposit: false,
        disablePrefix: false,
        showCreate: false,
        showUpdate: true,
        showCancel: true,
        disableRequestResupplyQuantity: false,
        disableLimitResupplyUser: false,
        disableNotConfirmProductWaveTransfer: false,
        disableAutomaticReallocation: false,
        disableConferenceWithDivergence: false,
        disabledDockPrintConsolidation: false,
        disableGenerateInventoryForSeparationDiscrepancy: false,
        disableAutoFinalizeNoDivergence: false,
        disableYellowLightValue: false,
        disableGreenLightValue: false,
        disableEnableStockMirror: false,
        disabletrackingDashboardSpeakOrderNumber: false,
        disabletrackingDashboardSpeakCustomerName: false,
        disableTrackingDashboardColumnSequence: false,
        disableTrackingDashboardOrderTypes: false,
        disableTrackingDashboardSoundStatuses: false,
        disableAssignPickingWave: false,
        disableAssignPickingDocument: false,
        disableAssignPickingLoad: false,
        disableUsesQrCode: false,
        disableAllocateBalanceAfterResupply: false,
      });
    }
  };

  createInput = (value, attr, label, placeholder, type = 'text', required, disabled) => (
    <div className="form-group row m-b-15" style={{ height: 40 }}>
      <label htmlFor={label} className="col-form-label col-md-4">
        {label}
      </label>
      <div className="col-md-5">
        <input
          type={type}
          className="form-control m-b-5"
          value={value || ''}
          onChange={(e) => this.setValue(attr, e.target.value)}
          placeholder={disabled ? '' : placeholder}
          required={required}
          disabled={disabled}
        />
      </div>
    </div>
  );

  createSelectDropDown = (value, attr, label, items, disabled) => (
    <div className="form-group row m-b-15" style={{ height: 40 }}>
      <label htmlFor={label} className="col-form-label col-md-4">
        {label}
      </label>
      <div className="col-md-5">
        <Select
          value={value || ''}
          onChange={(e) => this.setValueDrop(attr, e)}
          options={items}
          isDisabled={disabled}
          isClearable
          styles={{
            ...colourStyles,
            control: (base, { isDisabled }) => ({
              ...base,
              backgroundColor: isDisabled ? '#e9ecef' : 'white',
            }),
          }}
          placeholder={I18n.t('BEE144' /* Selecione... */)}
        />
      </div>
    </div>
  );

  createToggleBox = (item, attr, label, disabled) => (
    <div className="form-group row m-b-15" style={{ position: 'relative' }}>
      <label htmlFor={label} className="col-form-label col-md-4">
        { }
      </label>
      <div className="col-md-8">
        <div className="row">
          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              id={`customCheck${attr}`}
              className="custom-control-input"
              disabled={disabled}
              checked={item}
              name={attr}
              onChange={this.handleInputChange}
            />
            <label className="custom-control-label" htmlFor={`customCheck${attr}`}>
              {label}
            </label>
          </div>
        </div>
      </div>
    </div>
  );

  setValue = async (attr, value) => {
    if (attr === 'postalCode') {
      const newPostalCode = value;
      const { postalCode } = this.state;

      if (newPostalCode !== postalCode) {
        await this.setState({
          [`${attr}`]: value,
        });

        const re = /^([\d]{2})\.*([\d]{3})-*([\d]{3})/;

        if (re.test(newPostalCode)) {
          await this.searchViaCep(newPostalCode);
        } else {
          await this.cleanAddress();
        }
      }
      // Filtro para numeros maiores que 0, impedindo valores negativos.
    } else if (attr === 'limitProductsWave' || attr === 'limitResupplyUser') {
      if (parseInt(value, 10) >= 0 || value === 0) {
        await this.setState({
          [`${attr}`]: value,
        });
      }
    } else {
      await this.setState({
        [`${attr}`]: value,
      });
    }
  };

  setValueDrop = async (attr, value) => {
    if (attr === 'company') {
      await this.setState({
        [`${attr}`]: value ? value.value : null,
        [`${attr}Name`]: value ? value.label : '',
      });
    } else if (attr === 'withdraw') {
      await this.setState({
        [`${attr}User`]: value ? value.value : null,
        [`${attr}Name`]: value ? value.label : '',
      });
    } else if (attr === 'package') {
      await this.setState({
        [`${attr}Code`]: value ? value.value : null,
        [`${attr}Name`]: value ? value.label : '',
      });
    } else if (attr === 'qrCodeModel') {
      await this.setState({
        [`${attr}Code`]: value ? value.value : null,
        [`${attr}Name`]: value ? value.label : '',
      });
    } else {
      await this.setState({
        [`${attr}Deposit`]: value ? value.value : null,
        [`${attr}Name`]: value ? value.label : '',
      });
    }
  };

  cleanAddress = async () => {
    await this.setState({
      ibge: '',
      street: '',
      number: '',
      complement: '',
      district: '',
      city: '',
      state: '',
      country: '',
    });
  };

  searchViaCep = async (postalCode) => {
    const keepOnlyNumber = (value) => value.replace(/\D/g, '');
    const address = await getAddressByCep(keepOnlyNumber(postalCode));

    if (address.erro) {
      await this.cleanAddress();
    } else {
      await this.setState({
        street: address.logradouro,
        ibge: address.ibge,
        number: '',
        complement: '',
        district: address.bairro,
        city: address.localidade,
        state: address.uf,
        country: I18n.t('BEE103' /* Brasil */),
      });
    }
  };

  createBranchSubmit = async () => {
    const {
      branchId,
      code,
      name,
      company,
      email,
      phone,
      cnpj,
      stateRegistration,
      ibge,
      postalCode,
      street,
      number,
      complement,
      city,
      district,
      state,
      country,
      note,
      requestWeightDimensions,
      mandatoryWeightDimensions,
      partialInboundCheck,
      preConference,
      receiveLeftover,
      inboundCheckPlate,
      rulesPriority,
      separationMode,
      preReceiptDeposit,
      inboundDeposit,
      resaleDeposit,
      inventoryDeposit,
      divergenceDeposit,
      damageDeposit,
      rejectedDeposit,
      qualityDeposit,
      spareDeposit,
      intermediaryDeposit,
      withdrawUser,
      branchInInventory,
      pickingByLoad,
      usesCableCuttingPlan,
      usesCarrierSchedule,
      dispatch,
      consolidation,
      dockControl,
      blindConference,
      automaticSeparationAfterCuttingCables,
      automaticCheckAfterPicking,
      limitProductsWave,
      packageCode,
      packageName,
      mandatoryComplementAddress,
      requestResupplyQuantity,
      rulesPriorityResupply,
      restrictionPicking,
      limitResupplyUser,
      factoryDeposit,
      serialControlDeposit,
      prefix,
      notConfirmProductWaveTransfer,
      automaticReallocation,
      conferenceWithDivergence,
      dockPrintConsolidation,
      generateInventoryForSeparationDiscrepancy,
      separationDivergenceDeposit,
      autoFinalizeNoDivergence,
      restrictSearchSepDoc,
      productAddressBranchCapacity,
      yellowLightValue,
      greenLightValue,
      crossdockingDeposit,
      enableStockMirror,
      trackingDashboardSpeakOrderNumber,
      trackingDashboardSpeakCustomerName,
      trackingDashboardColumnSequence,
      trackingDashboardOrderTypes,
      trackingDashboardSoundStatuses,
      assignPickingWave,
      assignPickingDocument,
      assignPickingLoad,
      usesQrCode,
      qrCodeModelCode,
      allocateBalanceAfterResupply,
    } = this.state;

    const trackingDashboardSoundPayload = getTrackingDashboardSoundPayload(
      trackingDashboardSoundStatuses,
    );

    if (automaticCheckAfterPicking && !packageCode) {
      await addNotification(
        'danger',
        I18n.t('BEE2407' /* Insira Embalagem Padrão */),
        I18n.t(
          'BEE2408', /* O CheckBox "Conferência Automática Após Separação Por Documento" está selecionado */
        ),
        'top-right',
      );
      return;
    }

    try {
      const newBranch = await this.props.createBranch({
        branchId,
        code,
        name,
        restrictSearchSepDoc,
        companyCode: company,
        email,
        phone: phone ? phone.replace(/\D/g, '') : '',
        cnpj: cnpj ? cnpj.replace(/[^a-zA-Z0-9]/g, '').toUpperCase() : '',
        stateRegistration,
        ibge,
        postalCode: postalCode ? postalCode.replace(/\D/g, '') : '',
        street,
        number,
        complement,
        city,
        district,
        state,
        country,
        limitProductsWave,
        requestWeightDimensions,
        mandatoryWeightDimensions,
        preConference,
        receiveLeftover,
        productAddressBranchCapacity,
        partialInboundCheck,
        inboundCheckPlate,
        separationMode,
        prioritySuggest: rulesPriority.map((rule) => rule.value).toString(),
        preReceiptDeposit,
        inboundDeposit,
        resaleDeposit,
        inventoryDeposit,
        divergenceDeposit,
        separationDivergenceDeposit,
        damageDeposit,
        rejectedDeposit,
        qualityDeposit,
        spareDeposit,
        intermediaryDeposit,
        factoryDeposit,
        crossdockingDeposit,
        withdrawUser,
        branchInInventory,
        serialControlDeposit,
        pickingByLoad,
        usesCableCuttingPlan,
        usesCarrierSchedule,
        note,
        dispatch,
        consolidation,
        dockControl,
        blindConference,
        automaticSeparationAfterCuttingCables,
        automaticCheckAfterPicking,
        packageCode,
        packageName,
        mandatoryComplementAddress,
        requestResupplyQuantity,
        prioritySuggestResupply: rulesPriorityResupply.map((rule) => rule.value).toString(),
        restrictionPicking,
        limitResupplyUser,
        prefix,
        notConfirmProductWaveTransfer,
        automaticReallocation,
        conferenceWithDivergence,
        dockPrintConsolidation,
        generateInventoryForSeparationDiscrepancy,
        autoFinalizeNoDivergence,
        yellowLightValue,
        greenLightValue,
        enableStockMirror,
        trackingDashboardSpeakOrderNumber,
        trackingDashboardSpeakCustomerName,
        trackingDashboardColumnSequence: trackingDashboardColumnSequence
          ? trackingDashboardColumnSequence
            .sort((a, b) => Number(a.value) - Number(b.value))
            .map((item) => item.value)
            .join('|')
          : '',
        trackingDashboardOrderTypes: trackingDashboardOrderTypes
          ? trackingDashboardOrderTypes
            .sort((a, b) => Number(a.value) - Number(b.value))
            .map((item) => item.value)
            .join('|')
          : '',
        ...trackingDashboardSoundPayload,
        assignPickingWave,
        assignPickingDocument,
        assignPickingLoad,
        usesQrCode,
        qrCodeModelCode,
        allocateBalanceAfterResupply,
      });

      if (newBranch && newBranch.success === false) {
        await addNotification(
          'danger',
          I18n.t('BEE145' /* Filial */),
          I18n.t('BEE147', { 0: code } /* Erro ao incluir a Filial %{0}! */),
          'top-right',
        );
      } else {
        await addNotification(
          'success',
          I18n.t('BEE145' /* Filial */),
          I18n.t('BEE146', { 0: code } /* Filial %{0} incluída com sucesso! */),
          'top-right',
        );

        this.props.history.push(ROUTES.BRANCH_LIST);
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          await addNotification(
            'danger',
            I18n.t('BEE145' /* Filial */),
            `${error.code} - ${error.details || error.message}`,
            'top-right',
          );
        } else {
          await addNotification(
            'danger',
            I18n.t('BEE145' /* Filial */),
            I18n.t('BEE147', { 0: code } /* Erro ao incluir a Filial %{0}! */),
            'top-right',
          );
        }
      } else {
        await addNotification(
          'danger',
          I18n.t('BEE145' /* Filial */),
          I18n.t('BEE147', { 0: code } /* Erro ao incluir a Filial %{0}! */),
          'top-right',
        );
      }
    }
  };

  updateBranchSubmit = async () => {
    const {
      branchId,
      code,
      name,
      company,
      email,
      phone,
      cnpj,
      stateRegistration,
      ibge,
      postalCode,
      street,
      number,
      complement,
      city,
      district,
      state,
      country,
      note,
      requestWeightDimensions,
      mandatoryWeightDimensions,
      partialInboundCheck,
      preConference,
      receiveLeftover,
      inboundCheckPlate,
      rulesPriority,
      separationMode,
      preReceiptDeposit,
      inboundDeposit,
      resaleDeposit,
      inventoryDeposit,
      divergenceDeposit,
      damageDeposit,
      rejectedDeposit,
      qualityDeposit,
      spareDeposit,
      intermediaryDeposit,
      factoryDeposit,
      withdrawUser,
      branchInInventory,
      dispatch,
      consolidation,
      dockControl,
      blindConference,
      automaticSeparationAfterCuttingCables,
      pickingByLoad,
      usesCableCuttingPlan,
      usesCarrierSchedule,
      automaticCheckAfterPicking,
      limitProductsWave,
      packageCode,
      packageName,
      mandatoryComplementAddress,
      requestResupplyQuantity,
      rulesPriorityResupply,
      restrictionPicking,
      limitResupplyUser,
      serialControlDeposit,
      prefix,
      notConfirmProductWaveTransfer,
      automaticReallocation,
      conferenceWithDivergence,
      dockPrintConsolidation,
      generateInventoryForSeparationDiscrepancy,
      separationDivergenceDeposit,
      autoFinalizeNoDivergence,
      restrictSearchSepDoc,
      productAddressBranchCapacity,
      yellowLightValue,
      greenLightValue,
      crossdockingDeposit,
      enableStockMirror,
      trackingDashboardSpeakOrderNumber,
      trackingDashboardSpeakCustomerName,
      trackingDashboardColumnSequence,
      trackingDashboardOrderTypes,
      trackingDashboardSoundStatuses,
      assignPickingWave,
      assignPickingDocument,
      assignPickingLoad,
      usesQrCode,
      qrCodeModelCode,
      allocateBalanceAfterResupply,
    } = this.state;

    if (automaticCheckAfterPicking && !packageCode) {
      await addNotification(
        'danger',
        I18n.t('BEE2407' /* Insira Embalagem Padrão */),
        I18n.t(
          'BEE2408', /* O CheckBox "Conferência Automática Após Separação Por Documento" está selecionado */
        ),
        'top-right',
      );
      return;
    }

    const trackingDashboardSoundPayload = getTrackingDashboardSoundPayload(
      trackingDashboardSoundStatuses,
    );

    try {
      const updBranch = await this.props.updateBranch({
        branchId,
        name,
        restrictSearchSepDoc,
        companyCode: company,
        email,
        phone: phone ? phone.replace(/\D/g, '') : '',
        cnpj: cnpj ? cnpj.replace(/[^a-zA-Z0-9]/g, '').toUpperCase() : '',
        stateRegistration,
        ibge,
        postalCode: postalCode ? postalCode.replace(/\D/g, '') : '',
        street,
        number,
        complement,
        city,
        district,
        state,
        country,
        limitProductsWave,
        requestWeightDimensions,
        mandatoryWeightDimensions,
        preConference,
        receiveLeftover,
        productAddressBranchCapacity,
        partialInboundCheck,
        inboundCheckPlate,
        separationMode,
        prioritySuggest: rulesPriority.map((rule) => rule.value).toString(),
        preReceiptDeposit,
        inboundDeposit,
        resaleDeposit,
        inventoryDeposit,
        divergenceDeposit,
        separationDivergenceDeposit,
        damageDeposit,
        rejectedDeposit,
        qualityDeposit: qualityDeposit || '',
        spareDeposit: spareDeposit || '',
        intermediaryDeposit: intermediaryDeposit || '',
        factoryDeposit: factoryDeposit || '',
        crossdockingDeposit: crossdockingDeposit || '',
        withdrawUser,
        branchInInventory,
        serialControlDeposit,
        pickingByLoad,
        usesCableCuttingPlan,
        usesCarrierSchedule,
        note,
        dispatch,
        consolidation,
        dockControl,
        blindConference,
        automaticSeparationAfterCuttingCables,
        automaticCheckAfterPicking,
        packageCode,
        packageName,
        mandatoryComplementAddress,
        requestResupplyQuantity,
        prioritySuggestResupply: rulesPriorityResupply.map((rule) => rule.value).toString(),
        restrictionPicking,
        limitResupplyUser,
        prefix,
        notConfirmProductWaveTransfer,
        automaticReallocation,
        conferenceWithDivergence,
        dockPrintConsolidation,
        generateInventoryForSeparationDiscrepancy,
        autoFinalizeNoDivergence,
        yellowLightValue,
        greenLightValue,
        enableStockMirror,
        trackingDashboardSpeakOrderNumber,
        trackingDashboardSpeakCustomerName,
        trackingDashboardColumnSequence: trackingDashboardColumnSequence
          ? trackingDashboardColumnSequence
            .sort((a, b) => Number(a.value) - Number(b.value))
            .map((item) => item.value)
            .join('|')
          : '',
        trackingDashboardOrderTypes: trackingDashboardOrderTypes
          ? trackingDashboardOrderTypes
            .sort((a, b) => Number(a.value) - Number(b.value))
            .map((item) => item.value)
            .join('|')
          : '',
        ...trackingDashboardSoundPayload,
        assignPickingWave,
        assignPickingDocument,
        assignPickingLoad,
        usesQrCode,
        qrCodeModelCode,
        allocateBalanceAfterResupply,
      });

      if (updBranch) {
        await addNotification(
          'success',
          I18n.t('BEE148' /* Atualizar Filial */),
          I18n.t('BEE149', { 0: code } /* Atualização da Filial %{0} efetuada com sucesso! */),
          'top-right',
        );

        this.props.history.push(ROUTES.BRANCH_LIST);
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          await addNotification(
            'danger',
            I18n.t('BEE148' /* Atualizar Filial */),
            `${error.code} - ${error.message}`,
            'top-right',
          );
        } else {
          await addNotification(
            'danger',
            I18n.t('BEE148' /* Atualizar Filial */),
            I18n.t('BEE150', { 0: code } /* Erro ao atualizar a Filial %{0}! */),
            'top-right',
          );
        }
      } else {
        await addNotification(
          'danger',
          I18n.t('BEE148' /* Atualizar Filial */),
          I18n.t('BEE150', { 0: code } /* Erro ao atualizar a Filial %{0}! */),
          'top-right',
        );
      }
    }
  };

  rulePriority = async () => {
    const rules = BranchHelpers.listRulesStorage();
    const { prioritySuggest = [] } = this.state;

    let priority = 1;

    if (prioritySuggest && prioritySuggest.length > 0) {
      const priorityArray = prioritySuggest.split(',');

      if (priorityArray && priorityArray.length > 0) {
        return priorityArray.map((suggest) => {
          const rule = rules.find((rl) => parseInt(rl.value, 10) === parseInt(suggest, 10));
          const returnValue = {
            value: suggest,
            label: rule.label,
            priority: (priority += 1),
          };
          return returnValue;
        });
      }
    }

    return rules.map((rule) => {
      const returnValue = {
        value: rule.value,
        label: rule.label,
        priority: (priority += 1),
      };
      return returnValue;
    });
  };

  rulesPriorityResupply = async () => {
    const rulesResupply = BranchHelpers.listRulesResupply();
    const { prioritySuggestResupply = [] } = this.state;

    let priority = 1;

    if (prioritySuggestResupply && prioritySuggestResupply.length > 0) {
      const priorityArray = prioritySuggestResupply.split(',');

      if (priorityArray && priorityArray.length > 0) {
        return priorityArray.map((suggest) => {
          const rules = rulesResupply.find(
            (rl) => parseInt(rl.value, 10) === parseInt(suggest, 10),
          );
          const returnValue = {
            value: suggest,
            label: rules.label,
            priority: (priority += 1),
          };
          return returnValue;
        });
      }
    }

    return rulesResupply.map((rules) => {
      const returnValue = {
        value: rules.value,
        label: rules.label,
        priority: (priority += 1),
      };
      return returnValue;
    });
  };

  upPriority = async (requestResupplyQuantity) => {
    if (requestResupplyQuantity) {
      const { rulesResupply, rulesPriorityResupply } = this.state;

      const rSelect = rulesPriorityResupply.find(
        (rules) => parseInt(rules.value, 10) === parseInt(rulesResupply, 10),
      );
      const rUp = rulesPriorityResupply.find(
        (rules) => parseInt(rules.priority, 10) === parseInt(rSelect.priority - 1, 10),
      );

      if (!rUp) return;

      rSelect.priority -= 1;
      rUp.priority += 1;

      const newlist = rulesPriorityResupply.map((rules) => {
        if (rules.value === rSelect.value) rules.priority = rSelect.priority;
        if (rules.value === rUp.value) rules.priority = rUp.priority;

        return rules;
      });

      if (newlist) {
        newlist.sort((a, b) => (a.priority < b.priority ? -1 : 1));
        this.setState({
          rulesPriorityResupply: newlist,
        });
      }
    } else {
      const { ruleSelect, rulesPriority } = this.state;

      const rSelect = rulesPriority.find(
        (rule) => parseInt(rule.value, 10) === parseInt(ruleSelect, 10),
      );

      const rUp = rulesPriority.find(
        (rule) => parseInt(rule.priority, 10) === parseInt(rSelect.priority - 1, 10),
      );

      if (!rUp) return;

      rSelect.priority -= 1;
      rUp.priority += 1;

      const newlist = rulesPriority.map((rule) => {
        if (rule.value === rSelect.value) rule.priority = rSelect.priority;
        if (rule.value === rUp.value) rule.priority = rUp.priority;

        return rule;
      });

      if (newlist) {
        newlist.sort((a, b) => (a.priority < b.priority ? -1 : 1));
        this.setState({
          rulesPriority: newlist,
        });
      }
    }
  };

  downPriority = async (requestResupplyQuantity) => {
    if (requestResupplyQuantity) {
      const { rulesResupply, rulesPriorityResupply } = this.state;

      const rSelect = rulesPriorityResupply.find(
        (rules) => parseInt(rules.value, 10) === parseInt(rulesResupply, 10),
      );
      const rUp = rulesPriorityResupply.find(
        (rules) => parseInt(rules.priority, 10) === parseInt(rSelect.priority + 1, 10),
      );

      if (!rUp) return;

      rSelect.priority += 1;
      rUp.priority -= 1;

      const newlist = rulesPriorityResupply.map((rules) => {
        if (rules.value === rSelect.value) rules.priority = rSelect.priority;
        if (rules.value === rUp.value) rules.priority = rUp.priority;

        return rules;
      });

      if (newlist) {
        newlist.sort((a, b) => (a.priority < b.priority ? -1 : 1));
        this.setState({
          rulesPriorityResupply: newlist,
        });
      }
    } else {
      const { ruleSelect, rulesPriority } = this.state;

      const rSelect = rulesPriority.find(
        (rule) => parseInt(rule.value, 10) === parseInt(ruleSelect, 10),
      );

      const rDown = rulesPriority.find(
        (rule) => parseInt(rule.priority, 10) === parseInt(rSelect.priority + 1, 10),
      );

      if (!rDown) return;

      rSelect.priority += 1;
      rDown.priority -= 1;

      const newlist = rulesPriority.map((rule) => {
        if (rule.value === rSelect.value) rule.priority = rSelect.priority;
        if (rule.value === rDown.value) rule.priority = rDown.priority;

        return rule;
      });

      if (newlist) {
        newlist.sort((a, b) => (a.priority < b.priority ? -1 : 1));
        this.setState({
          rulesPriority: newlist,
        });
      }
    }
  };

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  render() {
    const {
      code,
      name,
      company,
      companyName,
      email,
      phone,
      cnpj,
      notConfirmProductWaveTransfer,
      stateRegistration,
      postalCode,
      street,
      number,
      prefix,
      automaticReallocation,
      conferenceWithDivergence,
      dockPrintConsolidation,
      complement,
      city,
      district,
      state,
      country,
      note,
      autoFinalizeNoDivergence,
      listCompany,
      limitProductsWave,
      limitResupplyUser,
      generateInventoryForSeparationDiscrepancy,
      enableStockMirror,
      assignPickingWave,
      assignPickingDocument,
      assignPickingLoad,
      usesQrCode,
      qrCodeModelCode,
      qrCodeModelName,
      allocateBalanceAfterResupply,
    } = this.state;

    const {
      mode,
      disableCode,
      disableName,
      disableCompany,
      disableEmail,
      disableLimitProductsWave,
      disablePhone,
      disableCNPJ,
      disableStateRegistration,
      disablePostalCode,
      disableStreet,
      disableNumber,
      disableComplement,
      disableCity,
      disableDistrict,
      disableState,
      disableNote,
      disableCountry,
      showCancel,
      showCreate,
      showUpdate,
      disableMandatoryComplementAddress,
      disableRequestResupplyQuantity,
      disableLimitResupplyUser,
      disableGenerateInventoryForSeparationDiscrepancy,
      disablePrefix,
      disableUsesQrCode,
      disableAllocateBalanceAfterResupply,
    } = this.state;

    const {
      mandatoryWeightDimensions,
      ruleSelect,
      rulesPriority,
      disableMandatoryProduct,
      disableRule,
      rulesPriorityResupply,
      rulesResupply,
      productAddressBranchCapacity,
      disableProductAddressBranchCapacity,
      disableEnableStockMirror,
    } = this.state;

    const {
      preReceiptDeposit,
      inboundDeposit,
      resaleDeposit,
      inventoryDeposit,
      divergenceDeposit,
      damageDeposit,
      rejectedDeposit,
      qualityDeposit,
      spareDeposit,
      intermediaryDeposit,
      disableDeposits,
      preReceiptName,
      inboundName,
      resaleName,
      inventoryName,
      divergenceName,
      damageName,
      disablePackage,
      rejectedName,
      qualityName,
      spareName,
      intermediaryName,
      listDeposit,
      listPackages,
      factoryDeposit,
      factoryName,
      restrictSearchSepDoc,
      crossdockingDeposit,
      crossdockingName,
      listQRCodes,
    } = this.state;

    const {
      pickingByLoad,
      usesCableCuttingPlan,
      packageCode,
      packageName,
    } = this.state;

    const {
      branchInInventory,
      disableBranchInInventory,
      disablePickingByLoad,
      disableUsesCableCuttingPlan,
      disableSerialControlDeposit,
      serialControlDeposit,
      mandatoryComplementAddress,
      requestResupplyQuantity,
      disableNotConfirmProductWaveTransfer,
      disableAutomaticReallocation,
      disableConferenceWithDivergence,
      disabledDockPrintConsolidation,
      separationDivergenceName,
      separationDivergenceDeposit,
      disableAutoFinalizeNoDivergence,
      disableRestrictSearchSepDoc,
      disableAssignPickingWave,
      disableAssignPickingDocument,
      disableAssignPickingLoad,
    } = this.state;

    const {
      trackingDashboardSpeakOrderNumber,
      trackingDashboardSpeakCustomerName,
      trackingDashboardColumnSequence,
      trackingDashboardOrderTypes,
      trackingDashboardSoundStatuses,
      disabletrackingDashboardSpeakOrderNumber,
      disabletrackingDashboardSpeakCustomerName,
      disableTrackingDashboardColumnSequence,
      disableTrackingDashboardOrderTypes,
      disableTrackingDashboardSoundStatuses,
      listOutboundOrderStatus,
      listSoundAlertStatuses,
      listOrderTypes,
    } = this.state;

    const {
      disableYellowLightValue, disableGreenLightValue, yellowLightValue, greenLightValue,
    } = this.state;

    let title = '';
    let breadActive = '';

    if (mode === 'create' || mode === 'copy') {
      title = I18n.t('BEE151' /* Nova Filial */);
    } else if (mode === 'edit') {
      title = I18n.t('BEE152' /* Editar Filial */);
      breadActive = `${code} - ${name}`;
    } else if (mode === 'detail') {
      title = I18n.t('BEE153' /* Detalhes Filial */);
      breadActive = `${code} - ${name}`;
    }

    return (
      <div className="slideUpTransition">
        <div className="d-flex align-items-center">
          <ol className="breadcrumb float-xl-left">
            <li className="breadcrumb-item">
              <i className="fas fa-home fa-fw m-t-10 m-r-5" />
              {' '}
              {I18n.t('BEE12' /* Início */)}
            </li>
            <li className="breadcrumb-item">{I18n.t('BEE13' /* Administração */)}</li>
            <li className="breadcrumb-item">{I18n.t('BEE14' /* Gerais */)}</li>
            <li className="breadcrumb-item">{I18n.t('BEE16' /* Filiais */)}</li>
            <li className="breadcrumb-item active">{breadActive}</li>
          </ol>
        </div>
        <div className="d-flex align-items-center mb-md-3 mb-2">
          <h1 className="page-header mb-0">{title}</h1>
        </div>
        <div className="row">
          <div className="col-xl-12 text-right">
            <div>
              <Panel className="panel-with-tabs">
                <PanelHeader noButton />
                <PanelBody>
                  <Nav tabs justified fill style={{ backgroundColor: 'lightgray' }}>
                    <NavItem>
                      <NavLink
                        className={this.state.activeTab === '1' ? 'active' : ''}
                        onClick={() => {
                          this.toggleTab('1');
                        }}
                      >
                        <span className="d-sm-none">Tab 1</span>
                        <span className="d-sm-block d-none">{I18n.t('BEE370' /* Dados */)}</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={this.state.activeTab === '2' ? 'active' : ''}
                        onClick={() => {
                          this.toggleTab('2');
                        }}
                      >
                        <span className="d-sm-none">Tab 2</span>
                        <span className="d-sm-block d-none">{I18n.t('BEE191' /* Geral */)}</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={this.state.activeTab === '3' ? 'active' : ''}
                        onClick={() => {
                          this.toggleTab('3');
                        }}
                      >
                        <span className="d-sm-none">Tab 3</span>
                        <span className="d-sm-block d-none">
                          {I18n.t('BEE36' /* Recebimento */)}
                        </span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={this.state.activeTab === '4' ? 'active' : ''}
                        onClick={() => {
                          this.toggleTab('4');
                        }}
                      >
                        <span className="d-sm-none">Tab 4</span>
                        <span className="d-sm-block d-none">{I18n.t('BEE43' /* Separação */)}</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={this.state.activeTab === '5' ? 'active' : ''}
                        onClick={() => {
                          this.toggleTab('5');
                        }}
                      >
                        <span className="d-sm-none">Tab 5</span>
                        <span className="d-sm-block d-none">{I18n.t('BEE18' /* Depósitos */)}</span>
                      </NavLink>
                    </NavItem>

                    <NavItem>
                      <NavLink
                        className={this.state.activeTab === '6' ? 'active' : ''}
                        onClick={() => {
                          this.toggleTab('6');
                        }}
                      >
                        <span className="d-sm-none">Tab 6</span>
                        <span className="d-sm-block d-none">
                          {I18n.t('BEE572' /* Inventário */)}
                        </span>
                      </NavLink>
                    </NavItem>

                    <NavItem>
                      <NavLink
                        className={this.state.activeTab === '7' ? 'active' : ''}
                        onClick={() => {
                          this.toggleTab('7');
                        }}
                      >
                        <span className="d-sm-none">Tab 7</span>
                        <span className="d-sm-block d-none">
                          {I18n.t('BEE2642' /* Ressuprimento */)}
                        </span>
                      </NavLink>
                    </NavItem>

                    <NavItem>
                      <NavLink
                        className={this.state.activeTab === '8' ? 'active' : ''}
                        onClick={() => {
                          this.toggleTab('8');
                        }}
                      >
                        <span className="d-sm-none">Tab 8</span>
                        <span className="d-sm-block d-none">{I18n.t('BEE4362' /* Alertas */)}</span>
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId="1">
                      <div className="row">
                        <div className="col-xl-12">
                          <Form
                            noPanel
                            setValue={this.setValue}
                            setValueDrop={this.setValueDrop}
                            inputs={(formContext) => [
                              formContext.createInput(
                                code,
                                'code',
                                `${I18n.t('BEE82' /* Código */)}:`,
                                I18n.t('BEE1781' /* Informe a filial */),
                                'text',
                                true,
                                disableCode,
                              ),
                              formContext.createInput(
                                name,
                                'name',
                                `${I18n.t('BEE83' /* Nome */)}:`,
                                I18n.t('BEE3671' /* Informe o nome da filial */),
                                'text',
                                true,
                                disableName,
                              ),
                              disableCompany
                                ? formContext.createInput(
                                  companyName,
                                  'company',
                                  `${I18n.t('BEE112' /* Empresa */)}:`,
                                  '',
                                  'text',
                                  false,
                                  disableCompany,
                                )
                                : formContext.createSelectDropDown(
                                  { value: company, label: companyName },
                                  'company',
                                  `${I18n.t('BEE112' /* Empresa */)}:`,
                                  listCompany,
                                  disableCompany,
                                  undefined,
                                  undefined,
                                  undefined,
                                  undefined,
                                  undefined,
                                  true,
                                ),
                              formContext.createInputMask(
                                cnpj,
                                'cnpj',
                                `${I18n.t('BEE85' /* CNPJ */)}:`,
                                I18n.t('BEE3668' /* Informe o CNPJ */),
                                '**.***.***/****-99',
                                true,
                                disableCNPJ,
                                undefined,
                                undefined,
                                undefined,
                                true,
                              ),
                              formContext.createInput(
                                stateRegistration,
                                'stateRegistration',
                                `${I18n.t('BEE117' /* Inscrição Estadual */)}:`,
                                I18n.t('BEE3669' /* Informe a inscrição estadual */),
                                'text',
                                true,
                                disableStateRegistration,
                              ),
                              formContext.createInputMask(
                                postalCode,
                                'postalCode',
                                `${I18n.t('BEE119' /* CEP */)}:`,
                                I18n.t('BEE3670' /* Informe o CEP */),
                                '99999-999',
                                true,
                                disablePostalCode,
                              ),
                              formContext.createInput(
                                street,
                                'street',
                                `${I18n.t('BEE121' /* Rua */)}:`,
                                I18n.t('BEE122' /* Informe a rua */),
                                'text',
                                true,
                                disableStreet,
                              ),
                              formContext.createInput(
                                number,
                                'number',
                                `${I18n.t('BEE123' /* Número */)}:`,
                                I18n.t('BEE124' /* Informe o número */),
                                'text',
                                false,
                                disableNumber,
                              ),
                              formContext.createInput(
                                complement,
                                'complement',
                                `${I18n.t('BEE125' /* Complemento */)}:`,
                                I18n.t('BEE126' /* Informe o complemento */),
                                'text',
                                false,
                                disableComplement,
                              ),
                              formContext.createInput(
                                district,
                                'district',
                                `${I18n.t('BEE127' /* Bairro */)}:`,
                                I18n.t('BEE128' /* Informe o bairro */),
                                'text',
                                true,
                                disableDistrict,
                              ),
                              formContext.createInput(
                                city,
                                'city',
                                `${I18n.t('BEE53' /* Cidade */)}:`,
                                I18n.t('BEE129' /* Informe a cidade */),
                                'text',
                                true,
                                disableCity,
                              ),
                              formContext.createInput(
                                state,
                                'state',
                                `${I18n.t('BEE87' /* Estado */)}:`,
                                I18n.t('BEE130' /* Informe o estado */),
                                'text',
                                true,
                                disableState,
                              ),
                              formContext.createInput(
                                country,
                                'country',
                                `${I18n.t('BEE88' /* País */)}:`,
                                I18n.t('BEE131' /* Informe o país */),
                                'text',
                                true,
                                disableCountry,
                              ),
                              formContext.createInput(
                                email,
                                'email',
                                `${I18n.t('BEE86' /* E-mail */)}:`,
                                I18n.t('BEE898' /* Informe o e-mail */),
                                'text',
                                false,
                                disableEmail,
                              ),
                              formContext.createInputMask(
                                phone,
                                'phone',
                                `${I18n.t('BEE133' /* Telefone */)}:`,
                                I18n.t('BEE134' /* Informe o telefone */),
                                FormatHelpers.getPhoneMask(phone, !disablePhone),
                                false,
                                disablePhone,
                              ),
                              formContext.createInput(
                                note,
                                'note',
                                `${I18n.t('BEE135' /* Observação */)}:`,
                                I18n.t('BEE136' /* Informe a observação */),
                                'text',
                                false,
                                disableNote,
                              ),
                            ]}
                          />
                        </div>
                      </div>
                    </TabPane>
                    <TabPane tabId="2">
                      <div className="row">
                        <div className="col-xl-12">
                          {this.createToggleBox(
                            serialControlDeposit,
                            'serialControlDeposit',
                            I18n.t('BEE2955' /* Controle de Etiquetas Seriadas por Depósito */),
                            disableSerialControlDeposit,
                          )}
                          {this.createToggleBox(
                            notConfirmProductWaveTransfer,
                            'notConfirmProductWaveTransfer',
                            I18n.t(
                              'BEE3321', /* Não confirma o produto na transferência por onda (entrada) */
                            ),
                            disableNotConfirmProductWaveTransfer,
                          )}
                          {this.createToggleBox(
                            usesQrCode,
                            'usesQrCode',
                            I18n.t('BEE4612' /* Utiliza configuração de QR Code */),
                            disableUsesQrCode,
                          )}
                          {this.createSelectDropDown(
                            qrCodeModelCode ? { value: qrCodeModelCode, label: qrCodeModelName || '' } : null,
                            'qrCodeModel',
                            `${I18n.t('BEE4614' /* Modelo de QR Code */)}:`,
                            listQRCodes,
                            disableUsesQrCode || !usesQrCode,
                          )}
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        {I18n.t(
                          'BEE4164', /* Limites de Horários e Cores - Painel de Carregamento */
                        )}
                        <div className="col-xl-8">
                          <Form
                            noPanel
                            setValue={this.setValue}
                            setValueDrop={this.setValueDrop}
                            inputs={(formContext) => [
                              formContext.createInput(
                                yellowLightValue,
                                'yellowLightValue',
                                `${I18n.t('BEE4162' /* Farol Amarelo */)}:`,
                                I18n.t('BEE4161' /* Informe em minutos. Exemplo: 30. */),
                                'number',
                                false,
                                disableYellowLightValue,
                              ),
                              formContext.createInput(
                                greenLightValue,
                                'greenLightValue',
                                `${I18n.t('BEE4160' /* Farol Verde */)}:`,
                                I18n.t('BEE4163' /* Informe em minutos. Exemplo: 120. */),
                                'number',
                                false,
                                disableGreenLightValue,
                              ),
                            ]}
                          />
                        </div>
                      </div>
                    </TabPane>
                    <TabPane tabId="3">
                      {this.createToggleBox(
                        mandatoryWeightDimensions,
                        'mandatoryWeightDimensions',
                        I18n.t('BEE786' /* Pesagem e medição obrigatórios */),
                        disableMandatoryProduct,
                      )}
                      {this.createToggleBox(
                        productAddressBranchCapacity,
                        'productAddressBranchCapacity',
                        I18n.t('BEE2658' /* Capacidade Produto x Classificação x Filial */),
                        disableProductAddressBranchCapacity,
                      )}
                      <div className="form-group row m-b-15">
                        <span className="col-form-label col-md-4">
                          {I18n.t('BEE787' /* Regra sugestão endereço */)}
                          :
                        </span>
                        <div className="col-md-4" style={{ paddingLeft: '0px' }}>
                          <select
                            multiple
                            className="form-control"
                            value={ruleSelect || ''}
                            disabled={disableRule}
                            onChange={(e) => this.setValue('ruleSelect', e.target.value)}
                          >
                            {rulesPriority.map((rule) => (
                              <option key={rule.value} value={rule.value}>
                                {rule.label}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="rdl-actions" style={{ margin: '10px' }}>
                          <button
                            className="rdl-move rdl-move-up"
                            type="button"
                            disabled={disableRule}
                            onClick={() => (ruleSelect.length === 0 ? '' : this.upPriority())}
                          >
                            <span className="fa fa-chevron-up" />
                            {' '}
                          </button>
                          <button
                            className="rdl-move rdl-move-down"
                            type="button"
                            disabled={disableRule}
                            onClick={() => (ruleSelect.length === 0 ? '' : this.downPriority())}
                          >
                            <span className="fa fa-chevron-down" />
                            {' '}
                          </button>
                        </div>
                      </div>
                    </TabPane>
                    <TabPane tabId="4">
                      <div className="ml-3">
                        <Form
                          noPanel
                          setValue={this.setValue}
                          setValueDrop={this.setValueDrop}
                          inputs={(formContext) => ([
                            this.createToggleBox(
                              pickingByLoad,
                              'pickingByLoad',
                              I18n.t('BEE4621' /* Separação por Carga */),
                              disablePickingByLoad,
                            ),
                            this.createToggleBox(
                              usesCableCuttingPlan,
                              'usesCableCuttingPlan',
                              I18n.t('BEE780' /* Utiliza plano de corte de cabo */),
                              disableUsesCableCuttingPlan,
                            ),
                            formContext.createCheckBoxWithCustomTooltip(
                              restrictSearchSepDoc,
                              'restrictSearchSepDoc',
                              I18n.t('BEE3662' /* Restringir informações na busca de Doc de separação */),
                              disableRestrictSearchSepDoc,
                              {
                                id: 'restrictSearchSepDocId',
                                type: 'info',
                                style: {
                                  color: 'blue', position: 'absolute', top: 3, paddingLeft: 5,
                                },
                                place: 'top',
                                content: (
                                  <>
                                    {I18n.t('BEE3664' /* Quando ativada, esta opção limitará as informações exibidas durante a busca de documentos de saída pelo coletor. */)}
                                    <br />
                                    {I18n.t('BEE4422' /* Assim, ao tentar assumir um documento, o separador visualizará apenas os detalhes essenciais do documento: */)}
                                    <br />
                                    {I18n.t('BEE4423' /* Número do Documento, Tipo, Pedido e Transportadora. */)}
                                  </>
                                ),
                              },
                            ),
                            this.createToggleBox(
                              dockPrintConsolidation,
                              'dockPrintConsolidation',
                              I18n.t(
                                'BEE3371', /* Imprimir etiquetas de consolidação ao fechar a doca */
                              ),
                              disabledDockPrintConsolidation,
                            ),
                            this.createToggleBox(
                              automaticReallocation,
                              'automaticReallocation',
                              I18n.t('BEE3383' /* Realocação Automática na Divergência da Separação */),
                              disableAutomaticReallocation || serialControlDeposit,
                            ),
                            this.createToggleBox(
                              conferenceWithDivergence,
                              'conferenceWithDivergence',
                              I18n.t('BEE4404' /* Permite divergências na conferência de saída. */),
                              disableConferenceWithDivergence,
                            ),
                            this.createToggleBox(
                              assignPickingWave,
                              'assignPickingWave',
                              I18n.t('BEE4407' /* Atribui Separação por Onda */),
                              disableAssignPickingWave,
                            ),
                            this.createToggleBox(
                              assignPickingDocument,
                              'assignPickingDocument',
                              I18n.t('BEE4805' /* Atribui Separação por Documento */),
                              disableAssignPickingDocument,
                            ),
                            this.createToggleBox(
                              assignPickingLoad,
                              'assignPickingLoad',
                              I18n.t('BEE4806' /* Atribui Separação por Carga */),
                              disableAssignPickingLoad,
                            ),
                          ])}
                        />
                      </div>
                      {this.createInput(
                        limitProductsWave,
                        'limitProductsWave',
                        `${I18n.t('BEE1664' /* Limite de Produto por Onda */)}:`,
                        I18n.t('BEE1667' /* Informe o Limite de Produto por Onda */),
                        'number',
                        false,
                        disableLimitProductsWave,
                      )}
                      {disablePackage
                        ? this.createInput(
                          packageName,
                          'package',
                          `${I18n.t('BEE2355' /* Embalagem Padrão */)}:`,
                          '',
                          'text',
                          false,
                          disablePackage,
                        )
                        : this.createSelectDropDown(
                          { value: packageCode, label: packageName },
                          'package',
                          `${I18n.t('BEE2355' /* Embalagem Padrão */)}:`,
                          listPackages,
                        )}
                      {this.createInput(
                        prefix,
                        'prefix',
                        `${I18n.t('BEE2990' /* Prefixo do código do produto: */)}:`,
                        I18n.t('BEE2991' /* Informe o prefixo */),
                        'text',
                        false,
                        disablePrefix,
                      )}
                    </TabPane>
                    <TabPane tabId="5">
                      <div className="row">
                        <div className="col-xl-12">
                          {disableDeposits
                            ? this.createInput(
                              preReceiptName,
                              'preReceipt',
                              `${I18n.t('BEE36' /* Recebimento */)}:`,
                              '',
                              'text',
                              false,
                              disableDeposits,
                            )
                            : this.createSelectDropDown(
                              {
                                value: preReceiptDeposit,
                                label: preReceiptName,
                              },
                              'preReceipt',
                              `${I18n.t('BEE36' /* Recebimento */)}:`,
                              listDeposit.filter((dep) => dep.inbound === 1),
                            )}
                          {disableDeposits
                            ? this.createInput(
                              inboundName,
                              'inbound',
                              `${I18n.t('BEE38' /* Armazenamento */)}:`,
                              '',
                              'text',
                              false,
                              disableDeposits,
                            )
                            : this.createSelectDropDown(
                              { value: inboundDeposit, label: inboundName },
                              'inbound',
                              `${I18n.t('BEE38' /* Armazenamento */)}:`,
                              listDeposit.filter((dep) => dep.inbound === 1),
                            )}
                          {disableDeposits
                            ? this.createInput(
                              resaleName,
                              'resale',
                              `${I18n.t('BEE571' /* Revenda */)}:`,
                              '',
                              'text',
                              false,
                              disableDeposits,
                            )
                            : this.createSelectDropDown(
                              { value: resaleDeposit, label: resaleName },
                              'resale',
                              `${I18n.t('BEE571' /* Revenda */)}:`,
                              listDeposit.filter((dep) => dep.resale === 1),
                            )}
                          {disableDeposits
                            ? this.createInput(
                              inventoryName,
                              'inventory',
                              `${I18n.t('BEE572' /* Inventário */)}:`,
                              '',
                              'text',
                              false,
                              disableDeposits,
                            )
                            : this.createSelectDropDown(
                              {
                                value: inventoryDeposit,
                                label: inventoryName,
                              },
                              'inventory',
                              `${I18n.t('BEE572' /* Inventário */)}:`,
                              listDeposit.filter((dep) => dep.inventory === 1),
                            )}
                          {disableDeposits
                            ? this.createInput(
                              divergenceName,
                              'divergence',
                              `${I18n.t('BEE3588' /* Divergência no Recebimento */)}:`,
                              '',
                              'text',
                              false,
                              disableDeposits,
                            )
                            : this.createSelectDropDown(
                              {
                                value: divergenceDeposit,
                                label: divergenceName,
                              },
                              'divergence',
                              `${I18n.t('BEE3588' /* Divergência no Recebimento */)}:`,
                              listDeposit.filter((dep) => dep.divergence === 1),
                            )}
                          {disableDeposits
                            ? this.createInput(
                              separationDivergenceName,
                              'separationDivergence',
                              `${I18n.t('BEE3586' /* Divergência na Separação */)}:`,
                              '',
                              'text',
                              false,
                              disableDeposits,
                            )
                            : this.createSelectDropDown(
                              {
                                value: separationDivergenceDeposit,
                                label: separationDivergenceName,
                              },
                              'separationDivergence',
                              `${I18n.t('BEE3586' /* Divergência na Separação */)}:`,
                              listDeposit.filter((dep) => dep.separationDivergence === 1),
                            )}
                          {disableDeposits
                            ? this.createInput(
                              damageName,
                              'damage',
                              `${I18n.t('BEE573' /* Avaria */)}:`,
                              '',
                              'text',
                              false,
                              disableDeposits,
                            )
                            : this.createSelectDropDown(
                              { value: damageDeposit, label: damageName },
                              'damage',
                              `${I18n.t('BEE573' /* Avaria */)}:`,
                              listDeposit.filter((dep) => dep.damage === 1),
                            )}
                          {disableDeposits
                            ? this.createInput(
                              rejectedName,
                              'rejected',
                              `${I18n.t('BEE177' /* Rejeitados */)}:`,
                              '',
                              'text',
                              false,
                              disableDeposits,
                            )
                            : this.createSelectDropDown(
                              { value: rejectedDeposit, label: rejectedName },
                              'rejected',
                              `${I18n.t('BEE177' /* Rejeitados */)}:`,
                              listDeposit.filter((dep) => dep.rejected === 1),
                            )}
                          {disableDeposits
                            ? this.createInput(
                              qualityName,
                              'quality',
                              `${I18n.t('BEE574' /* Qualidade */)}:`,
                              '',
                              'text',
                              false,
                              disableDeposits,
                            )
                            : this.createSelectDropDown(
                              { value: qualityDeposit, label: qualityName },
                              'quality',
                              `${I18n.t('BEE574' /* Qualidade */)}:`,
                              listDeposit.filter((dep) => dep.quality === 1),
                            )}
                          {disableDeposits
                            ? this.createInput(
                              spareName,
                              'spare',
                              `${I18n.t('BEE789' /* Sobra */)}:`,
                              '',
                              'text',
                              false,
                              disableDeposits,
                            )
                            : this.createSelectDropDown(
                              { value: spareDeposit, label: spareName },
                              'spare',
                              `${I18n.t('BEE789' /* Sobra */)}:`,
                              listDeposit.filter((dep) => dep.spare === 1),
                            )}
                          {disableDeposits
                            ? this.createInput(
                              intermediaryName,
                              'intermediary',
                              `${I18n.t('BEE2832' /* Intermediário */)}:`,
                              '',
                              'text',
                              false,
                              disableDeposits,
                            )
                            : this.createSelectDropDown(
                              {
                                value: intermediaryDeposit,
                                label: intermediaryName,
                              },
                              'intermediary',
                              `${I18n.t('BEE2832' /* Intermediário */)}:`,
                              listDeposit.filter((dep) => dep.intermediary === 1),
                            )}
                          {disableDeposits
                            ? this.createInput(
                              factoryName,
                              'factory',
                              `${I18n.t('BEE2873' /* Fábrica */)}:`,
                              '',
                              'text',
                              false,
                              disableDeposits,
                            )
                            : this.createSelectDropDown(
                              { value: factoryDeposit, label: factoryName },
                              'factory',
                              `${I18n.t('BEE2873' /* Fábrica */)}:`,
                              listDeposit.filter((dep) => dep.factory === 1),
                            )}
                          {disableDeposits
                            ? this.createInput(
                              crossdockingName,
                              'crossdocking',
                              `${I18n.t('BEE4347' /* Cross-Docking */)}:`,
                              '',
                              'text',
                              false,
                              disableDeposits,
                            )
                            : this.createSelectDropDown(
                              { value: crossdockingDeposit, label: crossdockingName },
                              'crossdocking',
                              `${I18n.t('BEE4347' /* Cross-Docking */)}:`,
                              listDeposit.filter((dep) => dep.crossdocking === 1),
                            )}
                        </div>
                      </div>
                    </TabPane>
                    <TabPane tabId="6">
                      {this.createToggleBox(
                        branchInInventory,
                        'branchInInventory',
                        I18n.t('BEE779' /* Filial em Inventário */),
                        disableBranchInInventory,
                      )}
                      {this.createToggleBox(
                        mandatoryComplementAddress,
                        'mandatoryComplementAddress',
                        I18n.t(
                          'BEE3191', /* Obrigatório gerar ficha para endereços complementares */
                        ),
                        disableMandatoryComplementAddress,
                      )}
                      {this.createToggleBox(
                        generateInventoryForSeparationDiscrepancy,
                        'generateInventoryForSeparationDiscrepancy',
                        I18n.t('BEE3583' /* Gerar inventário para discrepância de separação */),
                        disableGenerateInventoryForSeparationDiscrepancy,
                      )}
                      {this.createToggleBox(
                        autoFinalizeNoDivergence,
                        'autoFinalizeNoDivergence',
                        I18n.t('BEE3627' /* Finaliza automaticamente fichas sem divergências */),
                        disableAutoFinalizeNoDivergence,
                      )}
                      {this.createToggleBox(
                        enableStockMirror,
                        'enableStockMirror',
                        I18n.t('BEE4199' /* Permite espelhar o inventário geral */),
                        disableEnableStockMirror,
                      )}
                    </TabPane>
                    <TabPane tabId="7" onSubmit={(e) => e.preventDefault()}>
                      <Form
                        noPanel
                        setValue={this.setValue}
                        setValueDrop={this.setValueDrop}
                        inputs={(formContext) => [
                          formContext.createInput(
                            limitResupplyUser,
                            'limitResupplyUser',
                            `${I18n.t(
                              'BEE2838', /* Quantidade máxima Ressuprimentos por usuário */
                            )}:`,
                            I18n.t('BEE2839' /* Informe o máximo de Ressuprimentos por usuário */),
                            'number',
                            false,
                            disableLimitResupplyUser,
                            undefined,
                            4,
                            undefined,
                            'limitResupplyUser',
                            20,
                          ),
                          formContext.createCheckBoxes(
                            [
                              {
                                value: requestResupplyQuantity,
                                attr: 'requestResupplyQuantity',
                                disabled: disableRequestResupplyQuantity,
                              },
                            ],
                            `${I18n.t('BEE2643' /* Não sugerir a quantidade no ressuprimento */)}:`,
                            undefined,
                            ['col-md-3', 'col-md-auto'],
                          ),
                          formContext.createCheckBoxes(
                            [
                              {
                                value: allocateBalanceAfterResupply,
                                attr: 'allocateBalanceAfterResupply',
                                disabled: disableAllocateBalanceAfterResupply,
                              },
                            ],
                            `${I18n.t('BEE4630' /* Alocar saldo após o ressuprimento */)}:`,
                            undefined,
                            ['col-md-3', 'col-md-auto'],
                          ),
                        ]}
                      />
                      <div className="form-group row m-b-15">
                        <span className="col-form-label col-md-4 me-5">
                          {I18n.t('BEE2644' /* Fila de Priorização do Ressuprimentos */)}
                          :
                        </span>
                        <div className="col-md-4" style={{ marginLeft: '0.1rem' }}>
                          <select
                            multiple
                            className="form-control"
                            value={rulesResupply || ''}
                            disabled={disableRule}
                            onChange={(e) => this.setValue('rulesResupply', e.target.value)}
                          >
                            {rulesPriorityResupply.map((rule) => (
                              <option key={rule.value} value={rule.value}>
                                {rule.label}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="rdl-actions" style={{ margin: '10px' }}>
                          <button
                            className="rdl-move rdl-move-up"
                            type="button"
                            disabled={disableRule}
                            onClick={() => (rulesResupply.length === 0
                              ? ''
                              : this.upPriority('requestResupplyQuantity'))}
                          >
                            <span className="fa fa-chevron-up" />
                            {' '}
                          </button>
                          <button
                            className="rdl-move rdl-move-down"
                            type="button"
                            disabled={disableRule}
                            onClick={() => (rulesResupply.length === 0
                              ? ''
                              : this.downPriority('requestResupplyQuantity'))}
                          >
                            <span className="fa fa-chevron-down" />
                            {' '}
                          </button>
                        </div>
                      </div>
                    </TabPane>
                    <TabPane tabId="8">
                      <Form
                        noPanel
                        setValue={this.setValue}
                        setValueDrop={this.setValueDrop}
                        inputs={(formContext) => [
                          formContext.createSelectDropDownMulti(
                            trackingDashboardSoundStatuses,
                            `${I18n.t('BEE4765' /* Emitir alerta sonoro nos status */)}`,
                            'trackingDashboardSoundStatuses',
                            listSoundAlertStatuses,
                            undefined,
                            ['col-md-4', 'col-md-4'],
                            disableTrackingDashboardSoundStatuses,
                            this.keypressFunctionConfirm,
                          ),
                          formContext.createCheckBoxes(
                            [
                              {
                                value: trackingDashboardSpeakOrderNumber,
                                attr: 'trackingDashboardSpeakOrderNumber',
                                disabled: disabletrackingDashboardSpeakOrderNumber,
                              },
                            ],
                            I18n.t('BEE4425' /* Falar o código do pedido */),
                            undefined,
                            ['col-md-3', 'col-md-auto'],
                          ),
                          formContext.createCheckBoxes(
                            [
                              {
                                value: trackingDashboardSpeakCustomerName,
                                attr: 'trackingDashboardSpeakCustomerName',
                                disabled: disabletrackingDashboardSpeakCustomerName,
                              },
                            ],
                            I18n.t('BEE4426' /* Falar o nome do cliente */),
                            undefined,
                            ['col-md-3', 'col-md-auto'],
                          ),
                          formContext.createSelectDropDownMulti(
                            trackingDashboardColumnSequence,
                            `${I18n.t('BEE4367' /* Status visíveis no painel. */)}:`,
                            'trackingDashboardColumnSequence',
                            listOutboundOrderStatus,
                            undefined,
                            ['col-md-4', 'col-md-4'],
                            disableTrackingDashboardColumnSequence,
                            this.keypressFunctionConfirm,
                          ),
                          formContext.createSelectDropDownMulti(
                            trackingDashboardOrderTypes,
                            `${I18n.t('BEE4375' /* Tipos de Documentos visíveis no painel */)}:`,
                            'trackingDashboardOrderTypes',
                            listOrderTypes,
                            undefined,
                            ['col-md-4', 'col-md-4'],
                            disableTrackingDashboardOrderTypes,
                            this.keypressFunctionConfirm,
                          ),
                        ]}
                      />
                    </TabPane>
                  </TabContent>
                </PanelBody>
                <PanelFooter>
                  <Link
                    to={{
                      pathname: ROUTES.BRANCH_LIST,
                      state: { dice: this.props.location.dice },
                    }}
                  >
                    {showCancel ? (
                      <OneClickButton type="submit" className="btn btn-120 btn-white p-5 m-5">
                        {I18n.t('BEE99' /* Cancelar */)}
                      </OneClickButton>
                    ) : (
                      <OneClickButton type="submit" className="btn btn-120 btn-white p-5 m-5">
                        {I18n.t('BEE137' /* Voltar */)}
                      </OneClickButton>
                    )}
                  </Link>
                  {showCreate && (
                    <OneClickButton
                      type="button"
                      className="btn btn-120 btn-primary p-5 m-5"
                      onClick={() => this.createBranchSubmit()}
                    >
                      {I18n.t('BEE138' /* Criar */)}
                    </OneClickButton>
                  )}
                  {showUpdate && (
                    <OneClickButton
                      type="button"
                      className="btn btn-120 btn-primary p-5 m-5"
                      onClick={() => this.updateBranchSubmit()}
                    >
                      {I18n.t('BEE139' /* Atualizar */)}
                    </OneClickButton>
                  )}
                </PanelFooter>
              </Panel>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  packagesList: state.packages && state.packages.packagesList,
});

const mapDispatchToProps = (dispatch) => ({
  getBranch: (branchId) => dispatch(getBranch(branchId)),
  createBranch: (branch) => dispatch(createBranch(branch)),
  updateBranch: (branch) => dispatch(updateBranch(branch)),
  getCompaniesOptions: () => dispatch(getCompaniesOptions()),
  getDepositsOptions: () => dispatch(getDepositsOptions()),
  getUsersOptions: () => dispatch(getUsersOptions()),
  getPackagesList: () => dispatch(getPackagesList()),
  getOrdersTypeOptions: () => dispatch(getOrdersTypeOptions()),
  getAllQRCodes: () => dispatch(getAllQRCodes()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BranchForm));
